import React, { useCallback, useRef, useState } from 'react';
import { ConfigProvider, theme as antdTheme } from 'antd';
import CameraScanButton from './CameraScanButton';
import QRScanner from './QRScanner';
import './StaffScanWaiting.css';

// Preserve the page's USB validation: coupons accept barcodes, passports only ZLP.
const rawScan = value => typeof value === 'string' ? value.trim() || null : null;
const waitingTheme = {
  inherit: false,
  algorithm: antdTheme.defaultAlgorithm,
  token: { colorPrimary: '#007800', colorInfo: '#007800', colorText: '#1a1a1a', fontFamily: '"Noto Sans KR", sans-serif' },
};
export const ScanLabel = ({ children }) => <span className="ssw-label">{children}</span>;

export default function StaffScanWaiting({ image, alt, busy = false, blocked = false, busyText = '조회 중…', guide, onScan, error, testId, guideTestId }) {
  const [cameraOpen, setCameraOpen] = useState(false);
  const latest = useRef();
  latest.current = { busy, blocked, onScan };
  const pending = useRef(false);
  // ZXing retains its initial callback; read current modal/loading state via ref.
  const scan = useCallback(async raw => {
    if (pending.current || latest.current.busy || latest.current.blocked) return;
    pending.current = true;
    try { await latest.current.onScan(raw); } finally { pending.current = false; }
  }, []);
  return <ConfigProvider theme={waitingTheme}><main className="ssw" data-testid={testId} aria-busy={busy}>
    <div className="ssw-beacon" data-paused={busy || blocked || cameraOpen}>
      {!cameraOpen && <span className="ssw-frame" aria-hidden="true"><i /><i /><i /><i /><span className="ssw-light" /></span>}
      <div className="ssw-media">
        {cameraOpen ? <div className="ssw-camera"><QRScanner onScan={scan} extract={rawScan} enabled={!busy && !blocked} facingMode="environment" decodeAttemptIntervalMs={150} /></div> : <img className="ssw-art" src={image} alt={alt} draggable="false" />}
      </div>
    </div>
    <div className="ssw-status" role="status"><span className="bank-scan-signal" data-paused={busy || blocked} aria-hidden="true"><i /></span><h2>{busy ? busyText : '스캔 대기 중..'}</h2></div>
    <div className="ssw-caption"><div className="ssw-caption-content">
      <p className="ssw-guide" data-testid={guideTestId}>{busy ? '잠시만 기다려 주세요.' : guide}</p>
      <CameraScanButton className="ssw-camera-toggle" open={cameraOpen} disabled={busy || blocked} onClick={() => setCameraOpen(open => !open)} />
      {error && <div className="ssw-error" role="alert">{error}</div>}
    </div></div>
  </main></ConfigProvider>;
}
